<template>
  <section>
    <!--工具条-->
    <DriverMileageToolbar :buttonList="buttonList" @callFunction="callFunction" ref="child"></DriverMileageToolbar>

    <!--列表-->
    <el-table
      :data="driverMileageList"
      highlight-current-row
      v-loading="listLoading"
      @current-change="selectCurrentRow"
      @selection-change="handleSelectionChange"
      style="width: 100%;"
    >
      <el-table-column
        type="selection"
        width="55">
      </el-table-column>
      <el-table-column fixed="left" type="index" label="序号" width="60"></el-table-column>
      <!--<el-table-column fixed="left" prop="LineName" label="线路" width="80"></el-table-column>-->
      <el-table-column fixed="left" prop="DriverName" label="驾驶员" width="100"></el-table-column>
      <el-table-column v-for="(item,index) in dynamicTableHead" :key="index" :label="item.label" :property="item.property" :index="item.index">
        <template slot-scope="scope">
          {{scope.row[scope.column.property][scope.column.index].Mileage}}
        </template>
      </el-table-column>
      <el-table-column fixed="right" prop="TotalMileage" label="合计" width="100" sortable></el-table-column>
    </el-table>

    <!--工具条-->
    <el-col :span="24" class="toolbar">
      <el-pagination
        layout="total, sizes, prev, pager, next"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="page"
        :page-sizes="[10, 15, 20, 50, 100, 200]"
        :total="total"
        style="float:right;"
      ></el-pagination>
    </el-col>

    <!--补录界面-->
    <el-dialog
      title="补录"
      :visible.sync="makeUpFormVisible"
      v-model="makeUpFormVisible"
      :close-on-click-modal="false"
      width="30%"
    >
      <el-form :model="makeUpForm" label-width="80px" :rules="makeUpFormRules" ref="makeUpForm">
        <el-row>
          <el-col>
             <el-form-item label="补录日期" prop="DepartureDate" label-width="110px">
              <el-date-picker v-model="makeUpForm.DepartureDate" type="date" placeholder="选择补录日期" value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="makeUpFormVisible = false">取消</el-button>
        <el-button type="primary" @click.native="makeUpSubmit" :loading="makeUpLoading">提交</el-button>
      </div>
    </el-dialog>

  </section>
</template>

<script>
import util from "../../../util/date";
//import { getDriverMileageListPage,exportDriverMileage,getBusLinesListPage,makeUpDriverMileage } from "../../api/api";
import { getDriverMileageListPage,exportDriverMileage,makeUpDriverMileage } from "../../api/api";
import { getButtonList, getOperationButtonList } from "../../promissionRouter";
import DriverMileageToolbar from "../../components/QueryToolbar/DriverMileageToolbar";

export default {
  components: { DriverMileageToolbar },
  data() {
    return {
      filters: {
        totaltype:"核定里程", //统计类型
        driverId:"", //驾驶员Id
        departureDate: "" //选择时间
      },
      buttonList: [],
      operationButtonList: [],
      dynamicTableHead: [],
      driverMileageList: [], //司机里程列表
 //     busLiness: [], //线路列表
      total: 0,
      page: 1,
      pageSize: 10,   
      listLoading: false,
      sels: [], //列表选中列
      currentRow: null,
      makeUpFormVisible: false, //补录界面是否显示
      makeUpLoading: false,
      makeUpFormRules: {
        DepartureDate: [{ required: true, message: "请选择补录日期", trigger: "blur" }]
      },
      //补录界面数据
      makeUpForm: {
        DepartureDate: ""
      },
      multipleSelection: []
    };
  },
  methods: {
    selectCurrentRow(val) {
      this.currentRow = val;
    },
    callFunction(item) {
      this.filters = {
        departureDate: item.departureDate,
        totaltype: item.totaltype,
        driverId: item.driverId
      };
      this.getDriverMileage();
      this[item.Func].apply(this, item);
    },
    operationButtonFunction(item,row){
      this.currentRow = row;
      this[item.Func].apply(this,item);
    },
    handleSizeChange(val) {
      this.page = 1;
      this.pageSize = val;
      this.getDriverMileage();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getDriverMileage();
    },
    queryDriverMileage(){
      this.page = 1;
      this.getDriverMileage();
    },
    handleMakeUpDriverMileageData(){
      this.makeUpFormVisible = true;
    },
    //获取司机里程列表
    getDriverMileage() {
      let _this = this;
      let para = {
        departureDate: (_this.filters.departureDate === "" || _this.filters.departureDate === null)?this.defaultDate():_this.filters.departureDate,
        totaltype: _this.filters.totaltype,
        driverId: _this.filters.driverId,
        page: _this.page,
        pageSize: _this.pageSize
      };
      _this.listLoading = true;
      getDriverMileageListPage(para).then(res => {
        _this.total = res.data.dataCount;
        _this.driverMileageList = res.data.data;
        _this.listLoading = false;
        if(_this.driverMileageList.length > 0) {
          _this.dynamicTableHead = [];
          let driverMileageNodeItems = _this.driverMileageList[0].DriverMileageNodeItems;
          driverMileageNodeItems.forEach((item, index) => {
            _this.dynamicTableHead.push({ index: index, property: 'DriverMileageNodeItems' ,label: item.DateStr});
          });
        }
      });
    },
//    getBusLines(){
//      getBusLinesListPage().then(res => {
//        this.busLiness = res.data.response.data;
//       this.filters.busLinesId = this.busLiness.length > 0?this.busLiness[0].Id:"";
//        this.getDriverMileage();
//      });
//    },
    // 获取导出文件名称，若是1号则当月数据，否则30天的数据
    getFileName(){
      let _this = this;
   //   let busLiness = _this.busLiness.filter(it=>it.Id === _this.filters.busLinesId);
   //   let fileName = busLiness.length>0?busLiness[0].LineChineseName:'';
      let fileName = '';
      if(_this.filters.departureDate !== null && _this.filters.departureDate !== null){
        let date = new Date(_this.filters.departureDate);
        let d = date.getDate();
        if(d === 1){
          let m = date.getMonth() + 1;
          fileName += m + '月份';
        }else{
          let startDateStr = util.formatDate.format(date, "yyyy-MM-dd");
          let startDate = new Date(startDateStr);
          let endDate = startDate.setTime(startDate.getTime()+29*24*60*60*1000);
          let endDateStr = util.formatDate.format(new Date(endDate), "yyyy-MM-dd");
          fileName += startDateStr +'至'+ endDateStr;
        }
      }

      return fileName + '司机里程数据';
    },
    //设置默认日期
    defaultDate(){
      let date = new Date();
      let year = date.getFullYear().toString();
      let month = date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1).toString():(date.getMonth()+1).toString();
      let departureDate = year + '-' + month + '-01';
      this.$refs.child.setDepartureDate(departureDate);
      return departureDate;
    },
    selsChange: function(sels) {
      this.sels = sels;
    },
    //导出司机里程
    handleExportDriverMileage() {
      let _this = this;
      let para = {
        departureDate: (_this.filters.departureDate === "" || _this.filters.departureDate === null)?this.defaultDate():_this.filters.departureDate,
        totaltype: _this.filters.totaltype,
        driverId: _this.filters.driverId,
        page: _this.page,
        pageSize: _this.pageSize
      };
      exportDriverMileage(para).then(res => {
        let blob = new Blob([res.data], {
          type: "application/vnd.ms-excel",
        }); // 2.获取请求返回的response对象中的blob 设置文件类型，这里以excel为例
        let url = window.URL.createObjectURL(blob); // 3.创建一个临时的url指向blob对象
        // 4.创建url之后可以模拟对此文件对象的一系列操作，例如：预览、下载
        let a = document.createElement("a");
        a.href = url;
        let fileName = _this.getFileName();
        a.download = fileName+".xlsx";
        a.click();
        // 5.释放这个临时的对象url
        window.URL.revokeObjectURL(url);
      },
      (err) => {
        resolve(err.response);
      })
      .catch((error) => {
        Promise.reject(error);
      });
    },
    //补录
    makeUpSubmit: function() {
      let _this = this;
      this.$refs.makeUpForm.validate(valid => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.makeUpLoading = true;
            let para = Object.assign({}, this.makeUpForm);
            var user = JSON.parse(window.localStorage.user);
            if (user && user.uID > 0) {
              
            } else {
              this.$message({
                message: "用户信息为空，先登录",
                type: "error"
              });
              _this.$router.replace(
                _this.$route.query.redirect ? _this.$route.query.redirect : "/"
              );
            }

            makeUpDriverMileage(para).then(res => {
              if (util.isEmt.format(res)) {
                this.makeUpLoading = false;
                return;
              }
              if (res.data.success) {
                this.makeUpLoading = false;
                this.$message({
                  message: res.data.msg,
                  type: "success"
                });
                this.$refs["makeUpForm"].resetFields();
                this.makeUpFormVisible = false;
                this.getDriverMileage();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error"
                });
              }
            });
          });
        }
      });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    }
  },
  mounted() {
    this.getDriverMileage();

    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    //第一种写法，每个页面都需要写方法，但是可以做特性化处理
    // this.getButtonList(routers);
    
    //第二种写法，封装到 permissionRouter.js 中
    this.buttonList = getButtonList(this.$route.path, routers);
    this.operationButtonList = getOperationButtonList(this.$route.path, routers);
  }
}
</script>

<style scoped>

</style>
